import { API_BASE_URL, getHeaders } from './config'

export async function fetchDocuments(category?: string) {
  const url = category 
    ? `${API_BASE_URL}/documents?category=${category}`
    : `${API_BASE_URL}/documents`
    
  const response = await fetch(url, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch documents')
  }
  
  return response.json()
}

export async function fetchDocument(id: string) {
  const response = await fetch(`${API_BASE_URL}/documents/${id}`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch document')
  }
  
  return response.json()
}

export async function uploadDocument(file: File, category: string, productArea?: string) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('category', category)
  if (productArea) formData.append('product_area', productArea)
  
  const response = await fetch(`${API_BASE_URL}/documents`, {
    method: 'POST',
    headers: {
      // Don't set Content-Type, let browser set it with boundary
      ...getHeaders(),
      'Content-Type': undefined as any,
    },
    body: formData
  })
  
  if (!response.ok) {
    throw new Error('Failed to upload document')
  }
  
  return response.json()
}

export async function deleteDocument(id: string) {
  const response = await fetch(`${API_BASE_URL}/documents/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to delete document')
  }
  
  return response.json()
}

export async function fetchDocumentCategories() {
  const response = await fetch(`${API_BASE_URL}/documents/categories`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch categories')
  }
  
  return response.json()
}
